export const REQUEST_PREOPEN_CLAIM: string = 'PREOPEN_CLAIM';
export const REQUEST_OPEN_CLAIM_MANAGER: string = 'REQUEST_OPEN_CLAIM_MANAGER';
export const REQUEST_OPEN_CLAIM_GPO: string = 'REQUEST_OPEN_CLAIM_GPO';
export const REQUEST_MIGRATE_CLAIM: string = 'REQUEST_MIGRATE_CLAIM';
export const REQUEST_COMPLETE_CLAIM_LAWYER_GPO: string =
  'REQUEST_COMPLETE_CLAIM_LAWYER_GPO';
export const REQUEST_VALIDATE_COMPLETE_CLAIM: string =
  'REQUEST_VALIDATE_COMPLETE_CLAIM';
